@if ((!isSalable || maxQty < 6) && maxQty > 0) {
  <p class="p2 col-6 center m-b-3 m-b-0-s m-t-2-s"
    >
    {{ 'Hurry, Only % left' | translate : maxQty }}
  </p>
}

<action class="w-12 button p-r-0-s p-l-0-s"
  [class.is-disabled]="isDisabled"
  [status]="status"
  (error)="onAddToBasketError($event)"
  (click)="submit()"
  cy-basketAddButton>
  {{ buttonCopy }}
</action>
<result class="block"
[status]="status"></result>